import React from "react";
import Filters from "./Filters";
import ListTemplate, { listTemplateQueryKey } from "components/ListTemplate";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { cardLayout } from "./cardLayout";
import { useQueryClient } from "@tanstack/react-query";
import { useLoaderData } from "react-router";
import FlightApp from "flights/new/app";
import TrainModal from "train/TrainModal";

const GroundTransportListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.GroundTransportListFrontModel>();

  const queryClient = useQueryClient();

  const onShowChange = () => {
    queryClient.invalidateQueries([listTemplateQueryKey]);
  }

  return <>
    <FlightApp />
    <TrainModal />
    <ListTemplate
      title={RESX.GroundTransport.GroundTransports}
      filterSet="groundTransport_List"
      defaultFilters={viewModel.defaultFilters}
      initialInstruction={viewModel.initialInstruction}
      fetchFunction={window.CoreApi.GroundTransport.Paginated}
      getId={item => item.groundTransportId}
      layout={cardLayout(onShowChange)}
      filters={<Filters />}
      functions={{
        mapFilterValuesToInstruction,
        mapResponseToFilterValues
      }}
    />
  </>
};

export default GroundTransportListApp;
